/* Intro Lottie player shared by apc-shop and apc-sphere-gallery.
   Each section marks its root with [data-apc-intro-root] and drops a JSON
   config (<script data-apc-intro-config>) inside it. The animation plays over
   the section, then `is-revealed` on the root fades it out and animates the
   content in (CSS lives with each section). Classic script, no modules, so it
   runs even when module loading is broken. */
(function () {
  // Both sections include this script tag; only run once.
  if (window.__apcIntroLoaded) return;
  window.__apcIntroLoaded = true;

  function setup(configEl) {
    var root = configEl.closest('[data-apc-intro-root]');
    if (!root) return;

    var config = {};
    try {
      config = JSON.parse(configEl.textContent || '{}');
    } catch (e) {}

    var reveal = function () {
      if (root.classList.contains('is-revealed')) return;
      root.classList.add('is-revealed');
      var intro = root.querySelector('[data-apc-intro]');
      if (intro) {
        window.setTimeout(function () { intro.style.display = 'none'; }, (config.fadeMs || 600) + 50);
      }
    };

    // Hard fallback: whatever happens below, never leave the section hidden.
    window.setTimeout(reveal, 12000);

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // Section-specific skip marker (e.g. the sphere's newsletter success
    // state goes straight to the content). reveal() still animates it in.
    var skip = !!root.querySelector('[data-apc-intro-skip]');

    // Already seen this session, or no animation to play → reveal at once.
    if (config.once) {
      try {
        if (sessionStorage.getItem(config.sessionKey) === '1') { reveal(); return; }
      } catch (e) {}
    }
    if (skip || reduceMotion || !config.src) { reveal(); return; }

    var wire = function (anim) {
      var done = false;
      var finish = function () {
        if (done) return;
        done = true;
        if (config.once) {
          try { sessionStorage.setItem(config.sessionKey, '1'); } catch (e) {}
        }
        reveal();
        // Tear the player down once it has faded out.
        window.setTimeout(function () { anim.destroy(); }, (config.fadeMs || 600) + 100);
      };

      // Many Lottie files hold on the last frame for a beat after the visible
      // action ends. Reveal `endTrimMs` early so we don't sit on the background.
      var trimMs = config.endTrimMs || 0;
      if (trimMs > 0) {
        anim.addEventListener('DOMLoaded', function () {
          var fps = anim.frameRate || 30;
          var cutoff = anim.totalFrames - (trimMs / 1000) * fps;
          if (cutoff <= 0) return; // animation shorter than the trim → let `complete` handle it
          var onFrame = function () {
            if (anim.currentFrame >= cutoff) {
              anim.removeEventListener('enterFrame', onFrame);
              finish();
            }
          };
          anim.addEventListener('enterFrame', onFrame);
        });
      }

      anim.addEventListener('complete', finish);
      anim.addEventListener('data_failed', finish);
    };

    var play = function (lottie) {
      var mount = root.querySelector('[data-apc-intro-mount]');
      var anim = lottie.loadAnimation({
        container: mount,
        renderer: 'svg',
        loop: false,
        autoplay: true,
        path: config.src,
        rendererSettings: { preserveAspectRatio: 'xMidYMid meet', progressiveLoad: true },
      });
      anim.setSpeed(config.speed || 1);
      wire(anim);
    };

    // Player already present (e.g. another section loaded it) → play now.
    if (window.lottie) { play(window.lottie); return; }

    // Otherwise load the self-hosted SVG-only player (preloaded by the
    // section, served same-origin), then play. If it fails to load at all,
    // reveal so the page never stays stuck behind the overlay.
    var s = document.createElement('script');
    s.src = config.player;
    s.onload = function () { if (window.lottie) { play(window.lottie); } else { reveal(); } };
    s.onerror = reveal;
    document.head.appendChild(s);
  }

  var boot = function () {
    var configs = document.querySelectorAll('[data-apc-intro-config]');
    for (var i = 0; i < configs.length; i++) setup(configs[i]);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
